/**
 * customer.ts Common Script File
 *
 * @project Keep Property
 * @company Codendot <https://codendot.com>
 * @author Jawdat Sobh <jawdat@codendot.com>
 * @since Thursday, November 17, 2022, 11:15 AM GMT+2
 *
 */

import "@/lib/firebase"

(() => {

    function main()
    {
        // TODO...
    }

    document.addEventListener("readystatechange", async (event: any) => {
        if (event.target.readyState === 'complete') {
            import('@/sw')
            main()
        }
    })

})()
